export default "__VITE_ASSET__Dxti5ZCG__"